import { render } from "./BaugrundstueckStep2.vue?vue&type=template&id=5656b9e7&scoped=true"
import script from "./BaugrundstueckStep2.vue?vue&type=script&lang=js"
export * from "./BaugrundstueckStep2.vue?vue&type=script&lang=js"

import "./BaugrundstueckStep2.vue?vue&type=style&index=0&id=5656b9e7&scoped=true&lang=css"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5656b9e7"]])

export default __exports__